package com.nnod.landing.nodin

import com.nnod.app.nodin.buildNodInQrPayload
import com.nnod.landing.web.LandingRoute

fun LandingRoute.NodIn.appDeepLink(): String = buildNodInLink()

fun LandingRoute.NodIn.qrPayload(): String = appDeepLink()

private fun LandingRoute.NodIn.buildNodInLink(): String =
    buildNodInQrPayload(
        kind = kind.toRouteSegment(),
        idolName = idolName,
        campaignId = campaignId,
        eventName = eventName,
        scheduledTime = scheduledTime,
        displayCode = displayCode,
    )

private fun NodInLandingKind.toRouteSegment(): String = when (this) {
    NodInLandingKind.START -> "s"
    NodInLandingKind.END -> "e"
}
